import Vue from 'vue'
import Router from 'vue-router'
import MapView from './views/Map.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'mapView',
      component: MapView
    },
    {
      path: '/about',
      name: 'aboutPage',
      component: () => import('./views/aboutPage.vue')
    }
  ]
})

